export enum UnlockStateTypes {
    locked='locked',
    lockedLoggingIn='lockedLoggingIn',
    unlocking = 'unlocking',
    unlocked = 'unlocked',
  }

export enum LoginState {
    initialising = 'initialising',
    loggedIn = 'loggedIn',
    loggedOut = 'loggedOut',

}